import styled from '@emotion/styled';
import Breakpoints, {
  getBreakpointWithOffset,
} from '../design-utils/breakpoints';

export const SubsDetailLayout = styled.div`
  display: grid;
  align-items: start;
  @media only screen and (min-width: ${Breakpoints.md}) {
    grid-template-columns: 1fr 30%;
    column-gap: 30px;
  }
  @media screen and (max-width: ${Breakpoints.md}) {
    grid-template-columns: 100%;
  }
`;

export const ActionColumLayout = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto auto auto;
  grid-auto-flow: row;
  row-gap: 22px;
`;

export const ShowMd = styled.div`
  @media screen and (max-width: ${getBreakpointWithOffset('smp', -1)}) {
    display: none;
  }
  @media screen and (min-width: ${Breakpoints.lg}) {
    display: none;
  }
`;

export const HideSm = styled.div`
  @media screen and (max-width: ${Breakpoints.md}) {
    display: none;
  }
`;

export const ShowSm = styled.div`
  @media screen and (min-width: ${Breakpoints.md}) {
    display: none;
  }
`;

export const FlexContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ActionButtonContainer = styled.div<{ columns?: number }>`
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-rows: 1fr;
  grid-template-columns: repeat(${({ columns }) => columns}, 1fr);
  grid-template-rows: 1fr;
  gap: 20px 20px;
  column-gap: 20px;
`;

export const SpinnerContainer = styled.div`
  position: relative;
  padding: 100px 0;
`;

export const DetailWrapper = styled.div`
  max-width: 1010px;
  margin-left: auto;
  margin-right: auto;
`;

export const DetailTitle = styled.h1`
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 10px;
`;

export const ShipmentName = styled.p`
  margin-bottom: 2px;
  font-weight: 700;
  font-size: 14px;
`;

export const ShipmentBody = styled.p`
  margin-bottom: 10px;
  font-weight: 400;
  font-size: 14px;
`;

export const LocalDeliveryInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const LinkButton = styled.a`
  margin-left: 5px;
  text-decoration: underline;
  cursor: pointer;
`;

export const NotifAnchor = styled.a`
  cursor: pointer;
  text-decoration: underline;
`;

export const MenuWrapper = styled.div`
  .bundle-card__body {
    position: relative;
  }

  .bundle-action-dots {
    position: absolute;
    right: 0;
    top: -25px;

    svg {
      visibility: hidden;
    }
  }

  .bundle-action-list-container {
    position: absolute;
    right: 0;
  }

  .bundle-action-list {
    left: initial;
    right: 0;
    top: 100%;
    width: 260px;
  }
`;
